<template>
  <v-flex>
    <v-dialog v-if="this.modelProducto" v-model="dialogFormularioProducto" width="1400px" max-width="auto" persistent>
      <producto-formulario @cerrarFormularioProducto="dialogFormularioProducto = false" :modelProducto="this.modelProducto"
        :accion="this.accion" />
    </v-dialog>

    <v-card class="ma-2" color="rgb(250, 250, 250)">
      <v-toolbar :dark="!dark" dense :color="colorBarraFormulario" flat>
        <v-toolbar-title :dark="!dark">Inventario</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>

      
    </v-card>

    <v-row v-if="loading">
      <v-spacer />
      <v-row class="mt-12">
        <v-col class="mt-12">
          <v-progress-linear class="mt-12 mb-12" :color="colorAccent1" indeterminate width="200px" rounded
            height="6"></v-progress-linear>
        </v-col>
      </v-row>
      <v-spacer />
    </v-row>

    <v-card v-else class="ma-2" color="rgb(250, 250, 250, 1)">
      <v-card-text>
        <v-row v-if="productos" class="mt-0" justify="start" dense>
          <v-col cols="12" align="center">
            <v-data-table v-if="productos" locale="es" dense :headers="headersLargo" :items="productos"
              :server-items-length="productos.length" hide-default-footer
              class="elevation-1 alternating-rows bordered-table">

              <template v-slot:[`item.requiere_reposicion`]="{ item }">
                <v-chip small :color="item.requiere_reposicion ? 'error' : 'success'" text-color="white">
                  {{ item.requiere_reposicion ? 'Sí' : 'No' }}
                </v-chip>
              </template>

              <template v-slot:[`item.stock_fisico`]="{ item }">
                {{ formatStock(item.stock_fisico) }}
              </template>

              <template v-slot:[`item.stock_reservado`]="{ item }">
                {{ formatStock(item.stock_reservado) }}
              </template>

              <template v-slot:[`item.stock_disponible`]="{ item }">
                {{ formatStock(item.stock_disponible) }}
              </template>

              <template v-slot:[`item.stock_minimo`]="{ item }">
                {{ formatStock(item.stock_minimo) }}
              </template>

              <template v-slot:[`item.actions`]="{ item }">

                <v-chip label small class="mr-1 mt-1 mb-1" link :color="colorAccent3" @click="_showEditar(item)"
                    text-color="white">
                    Editar
                  </v-chip>
              </template>



              <template v-slot:no-data>
                No hay datos disponibles
              </template>

            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import ProductoFormulario from "../components/formularios/ProductoFormulario";

export default {
  components: {
    ProductoFormulario,
  },

  data: () => ({
    mostrarbusqueda: true,
    busquedaNombre: "",
    busquedaCodigo: "",
    accion: "",

    dialogFormularioProducto: false,
    modelProducto: null,

    options: {},
    currentPage: 1,
    itemsPerPage: 20,
    sortBy: 'nombre',

    headersLargo: [
      {
        text: "REQ. REPO",
        align: "center",
        sortable: false,
        value: "requiere_reposicion",
      },
      {
        text: "NOMBRE",
        align: "left",
        sortable: false,
        value: "nombre",
      },
      {
        text: "STOCK FÍSICO",
        align: "center",
        sortable: false,
        value: "stock_fisico",
      },
      {
        text: "STOCK RESERVADO",
        align: "center",
        sortable: false,
        value: "stock_reservado",
      },
      {
        text: "STOCK DISPONIBLE",
        align: "center",
        sortable: false,
        value: "stock_disponible",
      },
      {
        text: "STOCK MÍNIMO",
        align: "center",
        sortable: false,
        value: "stock_minimo",
      },
      {
        text: "",
        align: "center",
        sortable: false,
        value: "actions",
        width: "120px",
      },

    ],
  }),

  computed: {
    ...mapState([
      "loading",
      "drawer",
      "dark",

      "colorAccent1",
      "colorAccent3",
      "colorBarraFormulario",

      "colorFondo500",
      "colorFondo400",
      "colorFondo300",
      "colorFondo200",
      "colorFondo100",

      "colorFront500",
      "colorFront400",
      "colorFront300",
      "colorFront200",
      "colorFront100",

      "colorAccent2",
      "colorAccent1",
      "colorBarraFormulario",
    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),

    ...mapState("inventario", ["productos", "productoSelec", "totalProductos"]),
  },

  watch: {},

  mounted() {
    this._getProductos(true);
  },

  methods: {
    ...mapActions("inventario", ["getProductos", "getProducto"]),
    ...mapMutations("inventario", ["setProductoSelec"]),

    formatStock(value) {
      if (value === null || value === undefined) return '0';
      return parseFloat(value).toFixed(0);
    },

    handleUpdateOptions(newOptions) {
      // Solo actualizamos si realmente ha cambiado algo relevante
      if (newOptions.page !== this.currentPage || newOptions.itemsPerPage !== this.itemsPerPage) {
        this.currentPage = newOptions.page;
        this.itemsPerPage = newOptions.itemsPerPage;
        this._getProductos(false);
      }
    },

    async _getProductos(showload) {
      const params = {};

      params.page = this.currentPage;
      params.per_page = this.itemsPerPage;
      params.sort_by = this.sortBy;

      if (this.busquedaNombre != null && this.busquedaNombre != "") {
        params.nombre = this.busquedaNombre;
      }
      if (this.busquedaCodigo != null && this.busquedaCodigo != "") {
        params.codigo = this.busquedaCodigo;
      }
      await this.getProductos([this.access_token, params, showload]);
    },

    async _addMovimiento(item, action) {
      console.log('item:', item);
    },

    async _showEditar(item) {
      document.body.style.cursor = 'wait';
      try {
        await this.getProducto([this.access_token, item.id, false]);
        if (this.productoSelec) {
          let temp = JSON.parse(JSON.stringify(this.productoSelec));
          this.modelProducto = temp;
          this.accion = 'editar';
          this.dialogFormularioProducto = true;
        }
      } finally {
        document.body.style.cursor = 'default';
      }
    },
  },
};
</script>

<style scoped>
.alternating-rows>>>tbody tr:nth-child(even) {
  background-color: #ebebeb !important;
}

.bordered-table {
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.bordered-table ::v-deep th {
  border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.bordered-table ::v-deep td {
  border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.bordered-table ::v-deep th:last-child,
.bordered-table ::v-deep td:last-child {
  border-right: none !important;
}

/* Si también quieres líneas horizontales entre las filas */
.bordered-table ::v-deep tr {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
}

/* Si quieres un borde superior para la primera fila */
.bordered-table ::v-deep thead tr:first-child {
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
}
</style>
